module.exports = __webpack_public_path__ + "static/media/professor_slide_mobile_2.6a757e10.png";